import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import fMessage from '@/components/fMessage';
import { updateRewrite } from '../exhibitInfoPage';
import type { UpdateRewriteParams } from '../exhibitInfoPage';
import type { OnSync_Options_Action } from './types';

export const sideEffects = {
  *onSync_Options(
    { payload }: OnSync_Options_Action,
    { select, call }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );

    const params: UpdateRewriteParams = {
      exhibit_ID: collectionExhibitInfoPage.exhibit_ID,
      inheritOptions: collectionExhibitInfoPage.inheritOptions,
      customOptions: collectionExhibitInfoPage.customOptions,
    };
    const {
      data,
      errCode,
      ret,
      msg,
    }: {
      data: boolean;
      errCode: number;
      msg: string;
      ret: number;
    } = yield call(updateRewrite, params);
    if (ret !== 0 || errCode !== 0 || !data) {
      return fMessage(msg, 'error');
    }
    if (payload?.successMessage) {
      fMessage(payload?.successMessage);
    }
  },
};
